module.exports = __webpack_public_path__ + "static/media/approved.b66bf0dc.svg";